import { bindable } from 'aurelia-framework';
import './fader.scss';

export class Fader {
  @bindable faded: boolean = true;
}
